import { render, staticRenderFns } from "./ContractsFiltersSettings.vue?vue&type=template&id=56c8195a&scoped=true"
import script from "./ContractsFiltersSettings.vue?vue&type=script&lang=js"
export * from "./ContractsFiltersSettings.vue?vue&type=script&lang=js"
import style0 from "./ContractsFiltersSettings.vue?vue&type=style&index=0&id=56c8195a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8195a",
  null
  
)

export default component.exports